// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"92c136cc","71":"ab531973"}[chunkId] + ".chunk.js";
};